// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var SectionActionsPhase = function (x) {
    return x;
};
var tsBridgeSectionActionsPha = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("hidden"), new DTS_Types.TsTypeTypelevelString("draft"), new DTS_Types.TsTypeTypelevelString("content") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandSectionActionsPhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("SectionActionsPhase")) ]) ]));
    }
};
var showSectionActionsPhase = Data_Show.showString;
var sectionActionsPhaseToString = function (v) {
    return v;
};
var writeSectionActionsPhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(sectionActionsPhaseToString($20));
        };
    })()
};
var sectionActionsPhaseHidden = "hidden";
var sectionActionsPhaseDraft = "draft";
var sectionActionsPhaseContent = "content";
var sectionActionsPhaseFromString = function (value) {
    if (value === "hidden") {
        return new Data_Maybe.Just(sectionActionsPhaseHidden);
    };
    if (value === "draft") {
        return new Data_Maybe.Just(sectionActionsPhaseDraft);
    };
    if (value === "content") {
        return new Data_Maybe.Just(sectionActionsPhaseContent);
    };
    return Data_Maybe.Nothing.value;
};
var sectionActionsPhaseNamespace = {
    hidden: sectionActionsPhaseHidden,
    draft: sectionActionsPhaseDraft,
    content: sectionActionsPhaseContent
};
var readSectionActionsPhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = sectionActionsPhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid SectionActionsPhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.SectionActionsPhase (line 61, column 5 - line 63, column 86): " + [ v.constructor.name ]);
        });
    }
};
var ordSectionActionsPhase = Data_Ord.ordString;
var eqSectionActionsPhase = Data_Eq.eqString;
export {
    sectionActionsPhaseHidden,
    sectionActionsPhaseDraft,
    sectionActionsPhaseContent,
    sectionActionsPhaseNamespace,
    sectionActionsPhaseFromString,
    sectionActionsPhaseToString,
    eqSectionActionsPhase,
    ordSectionActionsPhase,
    showSectionActionsPhase,
    readSectionActionsPhase,
    writeSectionActionsPhase,
    tsBridgeSectionActionsPha
};
//# sourceMappingURL=index.js.map
